module.exports = __webpack_public_path__ + "static/media/videocam-on.9900fcc0.svg";